"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Basebox_1 = require("./Basebox");
Object.defineProperty(exports, "Basebox", { enumerable: true, get: function () { return Basebox_1.Basebox; } });
var Basebox_2 = require("./Basebox");
Object.defineProperty(exports, "BaseboxTrigger", { enumerable: true, get: function () { return Basebox_2.StyledTrigger; } });
//# sourceMappingURL=index.js.map